import { CompanyBasic } from './company-basic.model';
import { CompanyInfo } from './company-info.model';


export class CompanyModel {
  active?: boolean;
  id: number;
  companyId?: number;
  isDefault?: boolean;
  order?: number;
  name: string;
  description?: CompanyInfo;
  company?: CompanyBasic;

  constructor(data?: CompanyModel) {
    this.id = data.id || null;
    this.name = data.name || null;
    this.description = data.description || null;
  }
}
